import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { isEqual } from 'lodash'

// Actions
import { setCustomer, hasExtent } from '../../../../../actions/orders'
import { getCustomers } from '../../../../../actions/customers'

// Components
import Modal from '../../../../../shared/components/Modal'
import Confirm from '../../../../../shared/components/Confirm'
import Portal from '../../../../../shared/components/Portal'

// Utils
import { translation } from '../../../../../utils/helpers'

// Elements
import Button from '../../../../../shared/elements/button'
import LabelWrapper from '../../../../../shared/elements/labelWrapper'
import DropDown from '../../../../../shared/elements/dropDown'
import Divider from '../../../../../shared/elements/divider'

// Styles
import './index.scss'

class SetCustomer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      customerId: null,
      hasManualBaseExtent: null,
      hasManualAddonExtent: null,
      confirm: {
        open: false
      },
      expandModal: false  // Used to change size of modal when dropdown is open to prevent styling errors.
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
    this.renderConfirmText = this.renderConfirmText.bind(this)
    this.showConfirm = this.showConfirm.bind(this)
    this.isConfirmDisabled = this.isConfirmDisabled.bind(this)
    this.mustConfirm = this.mustConfirm.bind(this)
    this.onCustomerDropDownOpenChange = this.onCustomerDropDownOpenChange.bind(this)

    this.props.getCustomers(parseInt(this.props.auth.user.ShopId))
    this.props.hasExtent(this.props.item.Id).then((res) => {
      this.setState({
        hasManualBaseExtent: res.data.HasManualBaseExtent,
        hasManualAddonExtent: res.data.HasManualAddonExtent,
        hasManualBodyShopBaseExtent: res.data.HasManualBodyShopBaseExtent,
        hasManualBodyShopAddonExtent: res.data.HasManualBodyShopAddonExtent
      })
    })
  }

  onInputChange (e) {
    this.setState({
      customerId: parseInt(e.target.value)
    })
  }

  onConfirm (e) {
    this.props.setCustomer(this.props.item.Id, this.state.customerId).then((res) => {
      let custData = res.data.Customer
      let item = {...this.props.item}
      item.CustomerId = custData.CustomerId
      item.CustomerName = custData.CustomerName
      item.CustomerPhone = custData.CustomerPhone
      item.CustomerCity = custData.CustomerCity
      item.CustomerZip = custData.CustomerZip
      item.CustomerSelect = res.data.CustomerSelect
      this.props.updateOrder(item)
      this.props.close()

      // Toastr
      // window.toastr.success(translation('14911'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('14912'), translation('216'))
    })
  }

  showConfirm (e) {
    this.setState({
      confirm: { open: true }
    })
  }

  onAbort (e) {
    this.setState({
      confirm: { open: false }
    })
  }

  renderConfirmText () {
    return translation('14913')  // Et manuelt omfang er angivet for denne ordre... bla bla
  }

  onCustomerDropDownOpenChange (name, open) {
    this.setState({
      expandModal: open
    })
  }

  mustConfirm () {
    return this.state.hasManualBaseExtent === true || this.state.hasManualAddonExtent === true || this.state.hasManualBodyShopBaseExtent === true || this.state.hasManualBodyShopAddonExtent === true
  }

  isConfirmDisabled () {
    return this.state.hasManualBaseExtent === null || this.hasManualAddonExtent === null || this.state.hasManualBodyShopBaseExtent === null || this.state.hasManualBodyShopAddonExtent === null || this.state.customerId === 0 || this.state.customerId === null
  }

  render () {
    if (this.props.inModal) {
      return this.renderAsModal()
    } else {
      return this.renderContent()
    }
  }

  renderAsModal () {
    let modalButtonProps = null
    if (this.props.inModal) {
      modalButtonProps = {
        disabled: this.isConfirmDisabled(),
        actionLabelText: translation('14909'),
        onActionClick: this.mustConfirm() ? this.showConfirm : this.onConfirm
      }
    }

    return (
      <Modal
        show
        onClose={this.props.close}
        header={translation('2259')}
        bottomBarProps={modalButtonProps}
        >
        {this.renderContent()}
      </Modal>
    )
  }

  renderContent () {
    if (this.props.item.Id === undefined || this.props.item.Id === null) {
      return null
    }
    // let mustConfirm = this.state.hasManualBaseExtent === true || this.state.hasManualAddonExtent === true || this.state.hasManualBodyShopBaseExtent === true || this.state.hasManualBodyShopAddonExtent === true
    // let disabled = this.state.hasManualBaseExtent === null || this.hasManualAddonExtent === null || this.state.hasManualBodyShopBaseExtent === null || this.state.hasManualBodyShopAddonExtent === null || this.state.customerId === 0 || this.state.customerId === null
    const activeCustomers = this.props.customers.filter(_ => _.Active)
    // console.log('disabled ', disabled, 'inModal', this.props.inModal)
    let additionalClass = this.props.inModal && this.state.expandModal ? ' expandModal' : ''
    return (
      <div className={'poppedup padding colorInlinePopup form setCustomer' + additionalClass}>
        <LabelWrapper labelText={!this.props.inModal ? translation('2259') : ''}>
          <DropDown size={this.props.inModal ? 'l' : 'm'} value={this.state.customerId} name='CustomerId' onChange={this.onInputChange} onOpenChange={this.onCustomerDropDownOpenChange}>
            <option value='0'>{translation('2259')}</option>
            {activeCustomers.map((c, key) => <option value={c.CustomerId} key={key}>{c.Name}</option>)}
          </DropDown>
          {this.props.inModal && <Divider size={2} noLine />}
        </LabelWrapper>
        {!this.props.inModal && <Button size={'m'} disabled={this.isConfirmDisabled()} onClick={this.mustConfirm() ? this.showConfirm : this.onConfirm} labelText={translation('14909')} />}
        {this.state.confirm.open && (
          <Portal className='confirmModal' onPortalClose={this.onAbort.bind(this)}>
            <Confirm renderText={this.renderConfirmText} confirm={this.onConfirm.bind(this)} notConfirm={this.onAbort.bind(this)} />
          </Portal>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers
  }
}

export default connect(mapStateToProps, {
  setCustomer,
  getCustomers,
  hasExtent
})(SetCustomer)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/SetCustomer/index.js